import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import type { ICoachLabPool } from '../../aida/containers/Settings/CoachLab/labLogic';
import { useUserSession } from '../../models/hooks/appStateHooks';
import type { LevStandardQueryMeta } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'aida/coffee/coachLab/pool';

/** The real leads and recorded-call personas a Coach Lab manager can call for one persona bank. */
export function useCoachLabPoolQuery(bank: string | undefined) {
	const userSession = useUserSession();
	return useQuery({
		queryKey: [BASE_QUERY_KEY, bank],
		queryFn: ({ signal }) =>
			userSession.webServiceHelper.callAsync<ICoachLabPool>({
				method: 'GET',
				path: Api.ImpersonationBroker.composeApiUrl({ urlPath: `${BASE_QUERY_KEY}/${bank}` }),
				signal,
			}),
		enabled: !!bank,
		staleTime: Infinity,
		meta: {
			toastErrorMessage: 'Could not load the leads for this vertical',
			errorLogging: { category: 'CoachLab', action: 'CoachLabPoolQuery-Error' },
		} satisfies LevStandardQueryMeta,
	});
}
